import React from "react"

// Select V2 global (drop-in de <select>) — même logique clavier qu'InputV2 :
//  - Enter : si `nextRef` → focus la cible ; sinon si `onEnter` → onEnter(e) ; sinon rien.
//  - Maj+Enter : si `prevRef` → focus la cible précédente ; sinon rien.
// Toutes les autres props (value, onChange, style, disabled…) sont transmises telles quelles.

function focusTarget(ref) {
	if (!ref) return
	const node = ref.current !== undefined ? ref.current : ref
	if (node && typeof node.focus === "function") node.focus()
}

const SelectV2 = React.forwardRef(
	({ nextRef, prevRef, onEnter, onKeyDown, ...rest }, ref) => {
		const handleKeyDown = (e) => {
			if (e.key === "Enter") {
				if (e.shiftKey) {
					if (prevRef) {
						e.preventDefault()
						focusTarget(prevRef)
					}
				} else if (nextRef) {
					e.preventDefault()
					focusTarget(nextRef)
				} else if (onEnter) {
					e.preventDefault()
					onEnter(e)
				}
			}
			if (onKeyDown) onKeyDown(e)
		}
		return <select ref={ref} onKeyDown={handleKeyDown} {...rest} />
	},
)

SelectV2.displayName = "SelectV2"

export default SelectV2
